<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/userList/">Users</a></li>
      <li class="breadcrumb-item active" aria-current="page">View User</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="text-right float-right">
        <button (click)="editUser()" class="btn btn-orange ml-2">Edit User</button>
      </div>
    </div>
  </div>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"><b>Details</b></h2>
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>First Name</b> : {{viewUser?.firstName | titlecase}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Last Name</b> : {{viewUser?.lastName}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Email</b> : {{viewUser?.email}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Phone Number</b> : {{viewUser?.mobile}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-4">
              <label class="text-black"><b>Assign Roles</b></label>
              <div *ngFor="let user of usersRoles">
              {{user.userRole | replaceStatus}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/userList" class="btn btn-cancel">Close</button>
    </div>
  </div>
</div>
